import PaymentAllocationsTable from 'src/features/paymentAllocations/components/tables/PaymentAllocationsTable';
import { useFinancialDocumentTabContext } from 'src/features/financialDocuments/utils/tabContext';

/**
 * Allocations tab of the financial document dashboard.
 *
 * Creating an allocation is only meaningful for an issued, not-yet-paid document; the dashboard
 * resolves that condition once and passes it down.
 */
const FinancialDocumentAllocationsTab = () => {
    const { disableAllocationCreate, currency } = useFinancialDocumentTabContext();

    return <PaymentAllocationsTable disableCreateButton={disableAllocationCreate} currency={currency} />;
};

export default FinancialDocumentAllocationsTab;
